import rmskincareAPI from '../utils/rmskincareAPI'
import { CategoryGroupId } from '../enum/groupId'

const productApi = {
  getCategory: async () => {
    let result = await rmskincareAPI.get(
      `management/category/${CategoryGroupId.PRODUCT}`
    )
    return result.data.data
  },

  getProductByCategory: async (categoryId) => {
    let result = await rmskincareAPI.get(
      `/management/service?categoryId=${categoryId}`
    )
    return result.data.data
  },

  getCategoryAppointmentByGroupId: async (groupId) => {
    let result = await rmskincareAPI.get(`/management/category/appointment?groupId=${groupId}`);
    return result.data.data;
  },
  
  getListOfServiceByStr: async (str) => {
    let result = await rmskincareAPI.get(
      `/management/service/product?searchStr=${str}&status=1`,
      { timeout: 50000 }
    )
    return result.data.data
  },

  findProductById: async (id) => {
    let result = await rmskincareAPI.get(`/management/product/${id}`)
    return result.data.data
  },

  /* Product */
  getAllListOfProduct: async (groupId) => {
    const result = await rmskincareAPI.get(
      `/management/product/all?groupId=${groupId}&status=1`
    )
    return result.data.data
  },

  getAllListOfProductNew: async (groupId) => {
    const result = await rmskincareAPI.get(
      `/management/product/all/app?groupId=${groupId}&status=1`
    )
    return result.data.data
  },

  getAllListOfStore: async () => {
    const result = await rmskincareAPI.get(
      `/management/service/store`
    )
    return result.data.data
  },
  // getOnceCategoryAllProduct: async(categoryId, status) => {
  //   if(status){
  //     const result = await rmskincareAPI.put(`/management/product/?categoryId=${categoryId}&status=${status}`);
  //     return result.data.data;
  //   }else {
  //     const result = await rmskincareAPI.put(`/management/product/?categoryId=${categoryId}`);
  //     return result.data.data;
  //   }
  // },
  getListOfProduct: async (categoryId) => {
    const result = await rmskincareAPI.get(
      `/management/product?categoryId=${categoryId}`
    )
    return result.data.data
  },
  addProduct: async (requestBody) => {
    const result = await rmskincareAPI.post(`/management/product`, requestBody)
    return result.data.data
  },
  getProductById: async (productId) => {
    const result = await rmskincareAPI.post(`/management/product/${productId}`)
    return result.data.data
  },
  deleteProduct: async (productId) => {
    const result = await rmskincareAPI.delete(
      `/management/product/${productId}`
    )
    return result.data.data
  },

  // editProduct: async (productId, query) => {
  //   const result = await rmskincareAPI.put(
  //     `/management/product/${productId}?${query}`
  //   )
  //   return result.data.data
  // },
  editProduct:async(requestBody)=>{
    const result =await rmskincareAPI.post(
      `/management/product/edit?forceUpdate=false&productId=${requestBody.id}`,requestBody
    )
    return result.data.data
  },
  filterProduct: async(query)=>{
    const result = await rmskincareAPI.get(`/management/beauty/page/filter${query}`)
    return result
  },
  getConsumablesList: async () => {
    const result = await rmskincareAPI.get('/management/product/consumables?productTypes=2&status=1');
    return result.data.data;
  },

  /* Product Staff Config */
  getProductStaffConfig: async (productId) => {
    const result = await rmskincareAPI.get(`/management/product/${productId}/staff`)
    return result.data.data
  },
  saveProductStaffConfig: async (productId, staffList) => {
    const result = await rmskincareAPI.post(`/management/product/${productId}/staff`, staffList)
    return result.data.data
  },

  /* Product Resource Requirements */
  getProductResources: async (productId, locationId) => {
    const result = await rmskincareAPI.get(
      `/management/product/${productId}/resources?locationId=${locationId}`
    )
    return result.data.data
  },
  addProductResource: async (productId, resource) => {
    const result = await rmskincareAPI.post(
      `/management/product/${productId}/resource`, resource
    )
    return result.data.data
  },
  deleteProductResource: async (productId, resourceId) => {
    const result = await rmskincareAPI.delete(
      `/management/product/${productId}/resource/${resourceId}`
    )
    return result.data.data
  },

  /* Product Online Booking Config */
  getProductOnlineBooking: async (productId) => {
    const result = await rmskincareAPI.get(`/management/product/${productId}/online-booking`)
    return result.data.data
  },
  saveProductOnlineBooking: async (productId, config) => {
    const result = await rmskincareAPI.post(
      `/management/product/${productId}/online-booking`, config
    )
    return result.data.data
  },
}

export default productApi
